exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.redactor-box {\n\twidth: 100%;\n}\n", ""]);

// exports
